import React, { useCallback, useEffect } from 'react';
import block from 'bem-cn';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import dayjs from 'dayjs';

import Button from 'components/Button';
import Spinner from 'components/Spinner/view/desktop';

import usePragmaticTournament from 'features/ranking/model/usePragmaticTournament';

import { awardsList } from '../../../data';
import AgentItem from '../AgentItem';
import { useCountdown } from '../../../model/useCountdown';
import dogBackIMG from '../img/dogBackBgDestktop.webp';
import dogFrontIMG from '../img/dogFrontBgDesktop.webp';
import dogRightIMG from '../img/dogSideBgDesktop.webp';
import heartIMG from '../img/heart.webp';
import gift1IMG from './img/giftPragmatic1.webp';
import gift2IMG from './img/giftPragmatic2.webp';

import jokerIMG from '../img/joker.webp';
import lionsIMG from '../img/lions.webp';
import partyIMG from '../img/party.webp';

import './PragmaticTournament.scss';

const b = block('pragmatic-tournament-desktop');

const PragmaticTournament = () => {
  const locale = useSelector(state => state.locale.locale);
  const history = useHistory();
  const { date } = useCountdown();

  const {
    actionProcessing,
    month,
    toggleMonth,
    pragmaticLiveRanking,
    pragmaticSlotsRanking,
  } = usePragmaticTournament();

  const awardsListItems = awardsList('pragmatic');

  useEffect(() => {
    history.push('/');
  }, [])

  return (
    <div className={b()}>
      <Spinner isLoading={actionProcessing} />
      <img src={dogBackIMG} alt="bg" className={b('bg-img', { type: 'back' })} />
      <img src={dogFrontIMG} alt="bg" className={b('bg-img', { type: 'front' })} />
      <img src={dogRightIMG} alt="bg" className={b('bg-img', { type: 'right' })} />
      <div className={b('bg')}>
        <section className={b('header')}>
          <h1 className={b('header-title')}>{locale.pragmaticTournament}</h1>
          <span className={b('header-description')}>{locale.rankingDescription}</span>
        </section>

        <section className={b('awards')}>
          <img src={gift1IMG} alt="" className={b('awards-gift1')} />
          <img src={gift2IMG} alt="" className={b('awards-gift2')} />
          <h3 className={b('awards-title')}>{locale.pragmaticSlotsAwards}</h3>
          <div className={b('awards-container')}>
            {awardsListItems.slice(0, 3).map(item => (
              <img className={b('awards-img')} src={item.imgDesk} alt={item.key} />
            ))}
          </div>
        </section>

        <section className={b('awards', { withMargin: true })}>
          <img src={gift1IMG} alt="" className={b('awards-gift1', { type: 'small' })} />
          <img src={gift2IMG} alt="" className={b('awards-gift2', { type: 'small' })} />
          <h3 className={b('awards-title')}>{locale.pragmaticLiveAwards}</h3>
          <div className={b('awards-container')}>
            {awardsListItems.slice(3).map(item => (
              <img className={b('awards-img')} src={item.imgDesk} alt={item.key} />
            ))}
          </div>
        </section>

        <div className={b('agents-title')}>{locale.topAgents}</div>
        <h2 className={b('agents-title-bg')}>{locale.leaderBoard}</h2>
      </div>

      <div className={b('content')}>
        <div className={b('tables')}>
          <div className={b('agents')}>
            <h5 className={b('agents-note')}>{locale.peugeotByPragmatic}</h5>
            <div className={b('agents-header')}>
              <div className={b('agents-header-td')}>{locale.table.number}</div>
              <div className={b('agents-header-td')}>{locale.table.username}</div>
              <div className={b('agents-header-td')}>{locale.table.points}</div>
            </div>
            {pragmaticSlotsRanking?.agentsRanking
              ?.slice(0, 3)
              ?.map((item, index) => (
                <AgentItem key={item?.id} item={item} position={index + 1} iconByPosition />
              ))}
            {pragmaticSlotsRanking?.myRank?.position && (
              <div className={b('current-position')}>
                {locale.currentPosition.replace('{{value}}', pragmaticSlotsRanking?.myRank?.position + 1)}
              </div>)}
          </div>

          <div className={b('agents-wrapper')}>
            <img src={jokerIMG} alt="bg" className={b('bg-img-joker')} />
            <img src={jokerIMG} alt="bg" className={b('bg-img-joker', {type: 'blur'})} />
            <img src={lionsIMG} alt="bg" className={b('bg-img-lions')} />
            <img src={lionsIMG} alt="bg" className={b('bg-img-lions', {type: 'blur'})} />
            <img src={partyIMG} alt="bg" className={b('bg-img-party')} />
            <img src={partyIMG} alt="bg" className={b('bg-img-party')} />
            <img src={heartIMG} alt="bg" className={b('bg-img-heart')} />

            <div className={b('agents')}>
              <h5 className={b('agents-note')}>{locale.motoByPragmatic}</h5>
              <div className={b('agents-header')}>
                <div className={b('agents-header-td')}>{locale.table.number}</div>
                <div className={b('agents-header-td')}>{locale.table.username}</div>
                <div className={b('agents-header-td')}>{locale.table.points}</div>
              </div>
              {pragmaticLiveRanking?.agentsRanking
                ?.slice(0, 3)
                ?.map((item, index) => (
                  <AgentItem key={item?.id} item={item} position={index + 1} iconByPosition />
                ))}
              {pragmaticLiveRanking?.myRank?.position && (
                <div className={b('current-position')}>
                  {locale.currentPosition.replace('{{value}}', pragmaticLiveRanking?.myRank?.position + 1)}
                </div>
              )}
            </div>
          </div>

          <div className={b('footer')}>
            <div className={b('timer-container')}>
              <span>{locale.daysRemaining}</span>
              <span className={b('timer')}>{date}</span>
            </div>

            <section className={b('bottom')}>
              <div className={b('rules')}>
                {locale.rules}&nbsp;<span className={b('click-here')}>{locale.clickHere}</span>
              </div>
              <div className={b('button')}>
                <Button
                  size="low"
                  text={month === 'current' ? locale.topOfLastMonth : locale.topOfCurrentMonth}
                  callBack={toggleMonth}
                  color="purple"
                />
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PragmaticTournament;
